import { formatCurrency, formatDate } from '@angular/common';
import { BenefitsDetail, Check, PaystubInfo } from '@core/models';

import { BenefitType } from '@dashboard/enums';
import { WidgetDetail } from '@shared/models';
import { noWidget } from '@dashboard/constants';

//#region
export const buildWidget = (widgetConfig: WidgetDetail): WidgetDetail => {
  return widgetConfig.type ? widgetConfig : noWidget;
};

export const formatDay = (date: string) => formatDate(date, 'mediumDate', 'en-US');
export const formatAmount = (amount: number) => formatCurrency(amount, 'en-us', '$', '1.2-2');

export const randomNumToThree = (): number => Math.floor(Math.random() * 3);

export const buildMaxBalance = (maxBalance: string): string => {
  const appendHours = (hours: string): string => `${hours} hrs`;

  const isNumeric = (num: any) =>
    (typeof num === 'number' || (typeof num === 'string' && num.trim() !== '')) &&
    !isNaN(num as number);

  //* build Hours amount.
  const buildHours = (maxBalance: string): string => appendHours(parseFloat(maxBalance).toFixed(1));

  return isNumeric(maxBalance) ? buildHours(maxBalance) : maxBalance;
};

export const noHolidayBenefit = (benefits: BenefitsDetail) =>
  benefits.benefitName !== BenefitType.Holiday;

export function toPaystubInfo(check: Check): PaystubInfo {
  return {
    amount: formatAmount(check.netPay),
    checkId: check.checkId,
    day: formatDay(check.checkDate),
    didId: check.didId,
  };
}
